import {Observable} from 'rxjs';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as Api from './api';
import * as Actions from './actions';

const fetch = action$ =>
    action$.ofType(Actions.fetch.type).mergeMap(({payload}) => {
        return Api.fetchSensitive(payload.childId)
            .map(sensitive => Actions.fetchSuccess.action(sensitive))
            .catch(e => Observable.of(Actions.fetchFailed.action(e)));
    });

const update = action$ =>
    action$.ofType(Actions.update.type).mergeMap(({payload}) => {
        return Api.updateSensitive(payload.childId, payload.sensitive)
            .flatMap(() => [
                Actions.updateSuccess.action(payload.childId, payload.sensitive),
                GlobalEventActions.updateSuccess.action(i18next.t('childProfile.profileUpdated')),
            ])
            .catch(e => Observable.of(Actions.updateFailed.action(e)));
    });

export default combineEpics(fetch, update);
